<div class="container content mb-2">
    <div class="row">
        <div class="col-md-12">
            <h5 class="title-step mt-4" align="center"><img src="./assets/img/file-text2.svg" class="img-fluid ico-title" width="20"> Resumen de la activación</h5>
            <!-- Notificación -->
            <div class="alert alert-success" role="alert" *ngIf="orderInfo?.super_status === superStatus.in_process || orderInfo?.super_status === superStatus.active">
                <h4 class="alert-heading mt-2">
                    <div class="checkmark-white"></div>
                    <b *ngIf="!(typeOrder !== 'convergent' && typeOrder !== 'broadband' && typeMobile.altas.length && typeMobile.portas.length === 0)">En proceso</b>
                    <b *ngIf="typeOrder !== 'convergent' && typeOrder !== 'broadband' && typeMobile.altas.length && typeMobile.portas.length === 0">Alta tramitada</b>
                </h4>
                <!-- Convergente -->
                <p *ngIf="typeOrder === 'convergent'">
                    <!-- Todo altas -->
                    <ng-container *ngIf="typeMobile.altas.length && typeMobile.portas.length === 0">
                        El alta de {{ typeMobile.altas && typeMobile.altas.length && typeMobile.altas.length > 1 ? 'las líneas móviles' : 'la línea móvil' }} ya se ha realizado. El alta de la fibra se ha enviado y se ha iniciado el proceso para su activación.
                    </ng-container>
                    <!-- Todo portas -->
                    <ng-container *ngIf="typeMobile.altas.length === 0 && typeMobile.portas.length">
                        El alta de la fibra y la portabilidad de {{ typeMobile.portas && typeMobile.portas.length && typeMobile.portas.length > 1 ? 'las líneas móviles' : 'la línea móvil' }} se ha enviado y se ha iniciado el proceso para su activación.
                    </ng-container>
                    <!-- Altas y portas -->
                    <ng-container *ngIf="typeMobile.altas.length && typeMobile.portas.length">
                        El alta de {{ typeMobile.altas && typeMobile.altas.length && typeMobile.altas.length > 1 ? 'las líneas móviles' : 'la línea móvil' }} ya se ha realizado. El alta de la fibra y la portabilidad de {{ typeMobile.portas && typeMobile.portas.length && typeMobile.portas.length > 1 ? 'las líneas móviles' : 'la línea móvil' }} se ha enviado y se ha iniciado el proceso para su activación.
                    </ng-container>
                </p>
                <!-- Moviles -->
                <p *ngIf="typeOrder !== 'convergent' && typeOrder !== 'broadband'">
                    <!-- Todo altas -->
                    <ng-container *ngIf="typeMobile.altas.length && typeMobile.portas.length === 0">
                        El alta de {{ typeMobile.altas && typeMobile.altas.length && typeMobile.altas.length > 1 ? 'las líneas móviles' : 'la línea móvil' }} ya se ha realizado.
                    </ng-container>
                    <!-- Todo portas -->
                    <ng-container *ngIf="typeMobile.altas.length === 0 && typeMobile.portas.length">
                        La portabilidad de {{ typeMobile.portas && typeMobile.portas.length && typeMobile.portas.length > 1 ? 'las líneas móviles' : 'la línea móvil' }} se ha enviado y se ha iniciado el proceso para su activación.
                    </ng-container>
                    <!-- Altas y portas -->
                    <ng-container *ngIf="typeMobile.altas.length && typeMobile.portas.length">
                        El alta de {{ typeMobile.altas && typeMobile.altas.length && typeMobile.altas.length > 1 ? 'las líneas móviles' : 'la línea móvil' }} ya se ha realizado. La portabilidad de {{ typeMobile.portas && typeMobile.portas.length && typeMobile.portas.length > 1 ? 'las líneas móviles' : 'la línea móvil' }} se ha enviado y se ha iniciado el proceso para su activación.
                    </ng-container>
                </p>
                <!-- Solo fibra -->
                <p *ngIf="typeOrder === 'broadband'">
                    El alta de la fibra se ha enviado y se ha iniciado el proceso para su activación.
                </p>
            </div>
            <!-- Notificacion error -->
            <div class="alert alert-danger" role="alert" *ngIf="orderInfo?.super_status === superStatus.cancelled || orderInfo?.super_status === superStatus.rejected || orderInfo?.super_status === superStatus.error">
                <h4 class="alert-heading mt-2">
                    <b>{{ orderInfo?.status_description }}</b>
                </h4>
                <p>{{ orderInfo?.error_description && orderInfo?.error_description !== '' ? orderInfo?.error_description : 'Ha ocurrido un error durante la activación' }}</p>
            </div>
        </div>
    </div>
</div>

<div class="container content">
    <div class="row">
        <div class="col-md-12">
            <div class="jumbotron-norm mb-3">
                <div class="row ms-1">
                    <!-- Nº de contrato -->
                    <div class="col-lg-2">
                        <h5 align="left" class="tar-name-6 mt-2 mb-1">Nº de contrato</h5>
                        <h5 align="left" class="tar-name-7 mt-1">{{ contractId }}</h5>
                    </div>
                    <!-- Caducidad -->
                    <div class="col-lg-2">
                        <h5 align="left" class="tar-name-6 mt-2 mb-1">Fecha</h5>
                        <h5 align="left" class="tar-name-7 mt-1">{{date | date:'dd/MM/yyyy':'UTC+1'}}</h5>
                    </div>
                    <!-- Estado -->
                    <div class="col-lg-2">
                        <h5 align="left" class="tar-name-6 mt-2 mb-1">Estado</h5>
                        <h5 align="left" class="tar-name-7 mt-1 verde">{{ orderInfo?.status_description }}</h5>
                    </div>
                    <!-- Descripcion -->
                    <div class="col" *ngIf="orderInfo && orderInfo.error_description && orderInfo.error_description !== ''">
                        <h5 align="left" class="tar-name-6 mt-2 mb-1">Descripción</h5>
                        <h5 align="left" class="tar-name-7 mt-1">{{ orderInfo.error_description }}</h5>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container mt-2">
    <div class="row">
        <div class="col-md-12">

            <div class="card mb-3">
                <div class="card-header bg-rm">
                    <div class="d-flex justify-content-between align-items-center">
                        <div>
                            <h6 class="subtitulo-pack2"><b>Cliente</b></h6>
                        </div>
                    </div>
                </div>

                <div class="card-body bg-white">
                    <div class="row mt-4">
                        <div class="col-lg-8">
                            <!-- Nombre cliente -->
                            <h5 class="title-list ms-3">
                                <a class="text-list" *ngIf="order.customer.document_type != 4 ">
                                    <b>{{ order.customer.name + ' ' + order.customer.last_name + ' ' + order.customer.second_last_name }}</b>
                                </a>
                                <a class="text-list" *ngIf="order.customer.document_type == 4 ">
                                    <b>{{ order.customer.company_name }}</b>
                                </a>
                                <br><br>
                                <!-- MSISDN -->
                                <span class="font-list">
                                    <img src="./assets/img/phone.svg" class="img-fluid" width="13">
                                    Nº de contacto: <b>{{ order.customer.phone_number }}</b>
                                </span>
                                <br>
                                <!-- Tipo de alta -->
                                <span class="font-list">
                                    <img src="./assets/img/package2.svg" class="img-fluid" width="13">
                                    Tipo de alta: <b>
                                    <ng-container *ngIf="typeOrder === 'convergent'">
                                        {{ 'Alta fibra + ' + (order.mobiles[0]?.msisdn && order.mobiles[0].msisdn !== '' ? 'Portabilidad móvil' : 'Alta móvil') }}
                                    </ng-container>
                                    <ng-container *ngIf="typeOrder === 'mobile'">
                                        {{ order.mobiles && order.mobiles.length && order.mobiles[0].msisdn && order.mobiles[0].msisdn !== '' ? 'Portabilidad móvil' : 'Alta móvil' }}
                                    </ng-container>
                                    <ng-container *ngIf="typeOrder === 'broadband'">Solo Fibra</ng-container>
                                    <b class="info-secundaria" *ngIf="order.mobiles.length > 1">
                                        + {{ order.mobiles.length - 1 }} línea(s) adicional(es)
                                    </b>
                                </b>
                                </span>
                                <br *ngIf="order.mobiles && order.mobiles.length && order.mobiles[0].msisdn && order.mobiles[0].msisdn !== ''">
                                <!-- MSISDN -->
                                <span class="font-list" *ngIf="order.mobiles && order.mobiles.length && order.mobiles[0].msisdn && order.mobiles[0].msisdn !== ''">
                                    <img src="./assets/img/file-black.svg" class="img-fluid" width="13">
                                    Línea móvil: <b>{{ order.mobiles[0].msisdn }}</b>
                                </span>
                                <br>
                                <!-- Fecha de solicitud -->
                                <span class="font-list">
                                    <img src="./assets/img/clock.svg" class="img-fluid" width="13">
                                    Fecha de solicitud: <b>{{date | date:'dd/MM/yyyy':'UTC+1'}}</b>
                                </span>
                                <br>
                                <!-- Documento de identidad -->
                                <span class="font-list">
                                    <img src="./assets/img/file-black.svg" class="img-fluid" width="13">
                                    {{ orderInfo?.customer_document_type?.description }}: <b>{{ order.customer.document }}</b>
                                </span>
                                <br>
                                <!-- Nº de contrato -->
                                <span class="font-list">
                                    <img src="./assets/img/package2.svg" class="img-fluid" width="13"> Nº de contrato: <b>{{ contractId }}</b>
                                </span>
                                <br>
                                <!-- Comentarios -->
                                <!--<span class="font-list"> Comentarios: <b>-</b></span><br><br>-->
                            </h5>
                        </div>
                        <div align="right" class="col-lg-4">
                            <div class="col-lg-12 mb-2">
                                <span class="badge badge-pill badge-success font-list"
                                    *ngIf="(typeOrder === 'convergent' || typeOrder === 'broadband') && rateFtth">
                                    <span *ngIf="typeOrder === 'convergent'">
                                        {{ rateFtth.name + '+' + ratesMobiles[0]?.name + ': ' + priceWithIVA(rateFtth.rateAmount + ratesMobiles[0]?.rateAmount - rateFtth.discount).toFixed(0) }} €
                                    </span>
                                    <span *ngIf="typeOrder === 'broadband'">
                                        {{ rateFtth.name + ': ' + priceWithIVA(rateFtth.rateAmount).toFixed(0) }} €
                                    </span>
                                </span>
                            </div>
                            <div class="col-lg-12 mb-2" *ngFor="let mobile of order.mobiles; index as i">
                                <span class="badge badge-pill badge-success font-list" *ngIf="mobile.rate && !(typeOrder === 'convergent' && i === 0)">
                                    {{ mobile.rate?.name + ': ' + priceWithIVA(mobile.rate.rateAmount).toFixed(0) }} €
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>

<div class="container mt-2">
    <div class="row">
        <div class="col-md-12">

            <div class="accordion" id="accordionExample">
                <div class="card">
                    <div class="card-header bg-rm">
                        <div class="d-flex justify-content-between align-items-center">
                            <div>
                                <h6 class="subtitulo-pack2 ms-3">
                                    <img src="./assets/img/file-text-negro.svg" class="img-fluid ico-title" width="13">
                                    <b>Resumen de la tramitación</b>
                                </h6>
                            </div>
                        </div>
                    </div>

                    <div class="bg-white">
                        <div class="row">
                            <div class="col-md-12">
                                <ul class="list-group list-group-flush">
                                    <li class="list-group-item cuerpo-pack-2">
                                        <!-- Solo Fibra -->
                                        <div *ngIf="typeOrder === 'broadband' && rateFtth">
                                            <h5 align="left" class="tar-name-7 mt-2 ms-3">
                                                <b>Solo Fibra</b>
                                            </h5>

                                            <div class="resumen d-flex justify-content-between align-items-center">
                                                <span class="sidebar-info4 verde"> Conceptos</span>
                                                <small class="text-muted"></small>
                                            </div>

                                            <div class="resumen d-flex justify-content-between align-items-center">
                                                <!-- tarifa -->
                                                <span class="sidebar-info5">
                                                    <img src="./assets/img/package2.svg" class="img-fluid" width="13">
                                                    {{ rateFtth.name }}
                                                </span>
                                                <small class="text-muted">
                                                    <!-- Precio tarifa -->
                                                    <span class="sidebar-info3">
                                                        <b>{{ priceWithIVA(rateFtth.rateAmount).toFixed(0) }} €/mes</b>
                                                    </span>
                                                </small>
                                            </div>

                                            <div class="resumen d-flex justify-content-between align-items-center mt-2">
                                                <span class="sidebar-info">
                                                    <b>Total</b>
                                                </span>
                                                <small class="text-muted trash-carrito">
                                                    <!-- Precio tarifa -->
                                                    <span class="sidebar-info2"><b>{{ priceWithIVA(rateFtth.rateAmount).toFixed(0) }} €/mes</b></span>
                                                </small>
                                            </div>
                                        </div>

                                        <!-- RESUMEN MOVIL PACK -->
                                        <div *ngIf="typeOrder === 'convergent' && rateFtth && order.mobiles.length > 0">
                                            <h5 align="left" class="tar-name-7 mt-2 ms-3">
                                                <b>Fibra y móvil</b>
                                            </h5>

                                            <div class="resumen d-flex justify-content-between align-items-center">
                                                <span class="sidebar-info4 verde"> Conceptos</span>
                                                <small class="text-muted"></small>
                                            </div>

                                            <div class="resumen d-flex justify-content-between align-items-center">
                                                <!-- tarifa -->
                                                <span class="sidebar-info5"><img src="./assets/img/package2.svg" class="img-fluid" width="13">
                                                    {{ rateFtth.name }}
                                                </span>
                                                <small class="text-muted">
                                                    <!-- Precio tarifa -->
                                                    <span class="sidebar-info3">
                                                        <b>{{ priceWithIVA(rateFtth.rateAmount).toFixed(0) }} €/mes</b>
                                                    </span>
                                                </small>
                                            </div>

                                            <div class="resumen d-flex justify-content-between align-items-center" *ngIf="order.mobiles && order.mobiles.length">
                                                <!-- tarifa -->
                                                <span class="sidebar-info5">
                                                    <img src="./assets/img/package2.svg" class="img-fluid" width="13">
                                                    <span>{{ order.mobiles[0].rate?.name }} ({{ order.mobiles[0].rate?.contractType === 'postpaid' ? 'Pospago' : 'Prepago' }})</span>
                                                    <br>
                                                    <span>{{ order.mobiles[0].rate?.labelData }} + {{ order.mobiles[0].rate?.resumeLabelVoice }}</span>
                                                </span>
                                                <small class="text-muted">
                                                   <!-- Precio tarifa -->
                                                    <span class="sidebar-info3">
                                                        <b>{{ priceWithIVA(order.mobiles[0].rate.rateAmount).toFixed(0) }} €/mes</b>
                                                    </span>
                                                </small>
                                            </div>
                                            <div class="resumen d-flex justify-content-between align-items-center mt-2"  *ngIf="order.mobiles[0].msisdn !== '' && order.mobiles[0].processing_date != '' && order.mobiles[0].processing_date != undefined ">
                                                <!-- Info fecha porta -->
                                                <span class="sidebar-info5" >
                                                    <small>
                                                        Fecha de portabilidad: <strong>{{ order.mobiles[0].processing_date  | date: 'dd/MM/yyyy' : '+1000' }}</strong>
                                                    </small>
                                                </span>
                                            </div>

                                            <div class="resumen d-flex justify-content-between align-items-center mt-2">
                                                <span class="sidebar-info">
                                                    Descuento por fibra y móvil
                                                </span>
                                                <small class="text-muted trash-carrito">
                                                    <!-- Precio tarifa -->
                                                    <span class="sidebar-info2">
                                                        <b>-{{ priceWithIVA(rateFtth.discount).toFixed(0) }} €/mes</b>
                                                    </span>
                                                </small>
                                            </div>

                                            <div class="resumen d-flex justify-content-between align-items-center mt-2">
                                                <span class="sidebar-info">
                                                    <b>Total</b>
                                                </span>
                                                <small class="text-muted trash-carrito">
                                                    <!-- Precio tarifa -->
                                                    <span class="sidebar-info2">
                                                        <b>{{ priceWithIVA(+rateFtth.rateAmount + +order.mobiles[0].rate.rateAmount - +rateFtth.discount).toFixed(0) }} €/mes</b>
                                                    </span>
                                                </small>
                                            </div>
                                        </div>

                                        <!-- RESUMEN LÍNEA ADICIONAL -->
                                        <div *ngFor="let mobile of order.mobiles; index as i" [hidden]="typeOrder === 'convergent' && i === 0">
                                            <hr *ngIf="typeOrder !== 'mobile' || i > 0">

                                            <h5 align="left" class="tar-name-7 mt-2 ms-3">
                                                <b>{{ i === 0 ? 'Línea móvil principal' : 'Línea móvil adicional' }}</b>
                                            </h5>

                                            <!-- CONCEPTOS -->
                                            <div class="resumen d-flex justify-content-between align-items-center">
                                                <span class="sidebar-info4 verde"> Conceptos</span>
                                                <small class="text-muted"></small>
                                            </div>

                                            <div class="resumen d-flex justify-content-between align-items-center">
                                                <!-- tarifa -->
                                                <span class="sidebar-info5">
                                                    <img src="./assets/img/package2.svg" class="img-fluid" width="13">
                                                    <span>{{ mobile.rate?.name }} ({{ mobile.rate?.contractType === 'postpaid' ? 'Pospago' : 'Prepago' }})</span>
                                                    <br>
                                                    <span>{{ mobile.rate?.labelData }} + {{ mobile.rate?.resumeLabelVoice }}</span>
                                                </span>
                                                <small class="text-muted">
                                                    <!-- Precio tarifa -->
                                                    <span *ngIf="rateFtth && i === 0" class="sidebar-info3">
                                                        <b>{{ priceWithIVA(mobile.rate.rateAmount - rateFtth.discount).toFixed(0) }} €/mes</b>
                                                    </span>
                                                    <span *ngIf="rateFtth === null || i !== 0" class="sidebar-info3">
                                                        <b>{{ priceWithIVA(mobile.rate.rateAmount).toFixed(0) }} €/mes</b>
                                                    </span>
                                                </small>
                                            </div>
                                            <div class="resumen d-flex justify-content-between align-items-center mt-2"  *ngIf="mobile.msisdn !== '' && mobile.processing_date != '' && mobile.processing_date != undefined ">
                                                <!-- Info fecha porta -->
                                                <span class="sidebar-info5" >
                                                    <small>
                                                        Fecha de portabilidad: <strong>{{ mobile.processing_date  | date: 'dd/MM/yyyy' : '+1000' }}</strong>
                                                    </small>
                                                </span>
                                            </div>
                                            <div class="resumen d-flex justify-content-between align-items-center mt-2">
                                                <span class="sidebar-info"><b>Total</b></span>
                                                <small class="text-muted trash-carrito">
                                                    <!-- Precio tarifa -->
                                                    <span *ngIf="rateFtth && i === 0" class="sidebar-info2">
                                                        <b>{{ priceWithIVA(mobile.rate.rateAmount - rateFtth.discount).toFixed(0) }} €/mes</b>
                                                    </span>
                                                    <span *ngIf="rateFtth === null || i !== 0" class="sidebar-info2">
                                                        <b>{{ priceWithIVA(mobile.rate.rateAmount).toFixed(0) }} €/mes</b>
                                                    </span>
                                                </small>
                                            </div>
                                        </div>
                                        <hr>

                                        <!-- Importe Total -->
                                        <div class="resumen-total total d-flex justify-content-between align-items-center"
                                            *ngIf="(rateFtth && order.mobiles.length > 1) || (!rateFtth && order.mobiles.length > 1)">
                                            <h5 class="total-color"><b>total</b></h5>
                                            <h5 class="text-auto"><b>{{ priceWithIVA(totalPrice).toFixed(0) }} €/mes</b></h5>
                                        </div>
                                        <div class="resumen-total total d-flex justify-content-between align-items-center">
                                            <span class="total-color"><b>IVA incluido</b></span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container firma mt-4 mb-5">
    <div class="row">
        <div class="col-md-12">
            <div class="row">
                <div class="col-lg-6" *ngIf="orderInfo && (orderInfo.sepa_asset_id || orderInfo.contract_asset_id)">
                    <div class="card">
                        <div class="card-header">
                            <div class="d-flex justify-content-between align-items-center">
                                <div>
                                    <h6 class="subtitulo-pack2 ms-3">
                                        <b>Descarga de contratos</b>
                                    </h6>
                                </div>
                                <small class="text-muted">
                                    <div class="checkmark{{ allDownloaded() ? '' : '-disabled'}}"></div>
                                </small>
                            </div>
                        </div>
                        <ul class="list-group list-group-flush">
                            <li class="list-group-item cuerpo-pack-2">
                                <h5 align="left" class="tar-name-7 mt-2 ms-3">
                                    Hay <b>{{ orderInfo.sepa_asset_id && orderInfo.contract_asset_id ? '2 contratos' : '1 contrato ' }} para descarga</b>
                                </h5>
                                <div class="d-flex" *ngIf="orderInfo.contract_asset_id">
                                    <h5 align="left" class="tar-name-8 mt-1 ms-3 cursor-pointer" (click)="descargar('contrato')">
                                        <img src="./assets/img/file.svg" class="img-fluid ico-title" width="13" > Contrato
                                        <span *ngIf="downloaded.contract" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                                    </h5>
                                </div>
                                <span *ngIf="downloaded.contract_error" class="error-download-file">
                                    Contrato aún no disponible inténtalo de nuevo en unos segundos
                                </span>
                                <div class="d-flex" *ngIf="orderInfo.sepa_asset_id">
                                    <h5 align="left" class="tar-name-8 mt-1 ms-3 cursor-pointer" (click)="descargar('sepa')">
                                        <img src="./assets/img/file.svg" class="img-fluid ico-title" width="13" > SEPA
                                        <span *ngIf="downloaded.sepa" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                                    </h5>
                                </div>
                                <span *ngIf="downloaded.sepa_error" class="error-download-file">
                                    SEPA aún no disponible inténtalo de nuevo en unos segundos
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-6" *ngIf="orderInfo?.super_status === superStatus.in_process || orderInfo?.super_status === superStatus.active">
                    <div class="card">
                        <div class="card-header">
                            <div class="d-flex justify-content-between align-items-center">
                                <div>
                                    <h6 class="subtitulo-pack2 ms-3">
                                        <b>Subida de Documentación</b>
                                    </h6>
                                </div>
                                <small class="text-muted">
                                    <div class="checkmark{{ orderInfo && orderInfo.document_uploads.length && orderInfo.document_uploads.length < 2 ? '-disabled' : '' }}"></div>
                                </small>
                            </div>
                        </div>
                        <ul class="list-group list-group-flush">
                            <li class="list-group-item cuerpo-pack-2">
                                <h5 align="left" class="tar-name-7 mt-2 ms-3">Documentos subidos</h5>
                                <div *ngIf="orderInfo && orderInfo.document_uploads && orderInfo.document_uploads.length">
                                    <h5 *ngFor="let file of orderInfo.document_uploads" align="left" class="tar-name-8 mt-1 ms-3 verde cursor-pointer" (click)="descargar('other', file)">
                                        <img src="./assets/img/file.svg" class="img-fluid ico-title" width="13"> {{ file.file_name }}
                                        <span *ngIf="file.downloaded" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                                    </h5>
                                </div>
                                <div align="center" class="mt-5 mt-2 mb-2">
                                    <a href="#!" (click)="showErrorUploadFile = false" data-toggle="modal" data-target="#documentacion" class="btn btn-green btn-sm btn-block">Subir documentación</a>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- MODALES -->
<div class="modal fade" id="contratos" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" style="display: none;" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">

            <div class="modal-header">
                <h5 class="modal-title" >Firma de contratos</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"><img src="./assets/img/times.svg" class="img-fluid ico-title" width="20"></span>
                </button>
            </div>

            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12">
                        <h6 class="subtitulo-pack4">
                            Listado de contratos
                        </h6>
                        <div class="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups">
                            <div class="btn-group me-2" role="group" aria-label="" (click)="descargar('contrato')">
                                <div class="jumbotron-doc pending-doc">
                                    <h6 class="subtitulo-pack3">
                                        <b>Contrato</b>
                                    </h6>
                                    <h6 class="subtitulo-pack3"><img src="./assets/img/clock.svg" class="img-fluid ico-title" width="10"> Descargar</h6>
                                </div>
                            </div>
                            <div class="btn-group me-2" role="group" aria-label="" (click)="descargar('sepa')">
                                <div class="jumbotron-doc pending-doc">
                                    <h6 class="subtitulo-pack3">
                                        <b>Sepa</b>
                                    </h6>
                                    <h6 class="subtitulo-pack3"><img src="./assets/img/clock.svg" class="img-fluid ico-title" width="10"> Descargar</h6>
                                </div>
                            </div>
                        </div>
                        <div class="bb-line"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="documentacion" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" style="display: none;" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">

            <div class="modal-header">
                <h5 class="modal-title" >Documentación</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"><img src="./assets/img/times.svg" class="img-fluid ico-title" width="20"></span>
                </button>
            </div>

            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12">
                        <!-- IBAN -->
                        <div *ngIf="orderInfo && orderInfo.document_uploads && orderInfo.document_uploads.length">
                            <ng-container *ngFor="let file of orderInfo.document_uploads">
                                <div class="d-flex justify-content-between align-items-center">
                                    <div>
                                        <h6>
                                            <span class="badge badge-pill badge-success">Subido</span>
                                        </h6>
                                    </div>
                                    <small class="text-muted">
                                        <h6 class="subtitulo-pack3">{{ file.file_name }}</h6>
                                    </small>
                                </div>
                                <div class="bb-line"></div>
                                <br>
                            </ng-container>
                        </div>

                        <div class="area mb-4">
                            <div id="dropZone"
                                (drop)="dropFile($event)"
                                (dragover)="allowDrop($event)"
                                (click)="inputFile.click()">
                                <img *ngIf="!uploadingFile"
                                    src="./assets/img/upload-cloud.svg"
                                    id="dropZoneImg"
                                    class="img-fluid mb-2"
                                    width="35">
                                <img *ngIf="uploadingFile"
                                    src="./assets/img/spinner_rm.svg"
                                    class="img-fluid"
                                    width="30">
                                <input type="file" name="file" id="fileBtn" (change)="fileChanged($event)" style="visibility: hidden; width:0; height:0" #inputFile>
                                <br>
                                <span style="font-size: medium;">Haz click sobre el icono para seleccionar un archivo o arrastralo al área de punteada</span>
                            </div>
                        </div>
                        <div *ngIf="showErrorUploadFile">
                            Error al subir documentación. Por favor, inténtelo de nuevo más tarde
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
